import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import DataGridCell from './DataGridCell';

export function dateCell(params: GridRenderCellParams<any>) {
  const value = params.value;

  const isValidDate = value && dayjs(value).isValid();
  const formattedDate = isValidDate ? dayjs(value).format('DD/MM/YYYY') : '';

  return <DataGridCell content={formattedDate ?? ''} />;
}
